import { Pagination } from "../molecules/Pagination";

interface DataTableProps<T> {
  title: string;
  headers: string[];
  data: T[];
  renderRow: (item: T) => React.ReactNode;
  filters?: React.ReactNode;
  actions?: React.ReactNode;
  currentPage: number;
  onPageChange: (page: number) => void;
  hasNext?: boolean;
  hasPrevious?: boolean;
}

export function DataTable<T extends { id: string }>({
  title,
  headers,
  data,
  renderRow,
  filters,
  actions,
  currentPage,
  onPageChange,
  hasNext = true,
  hasPrevious,
}: DataTableProps<T>) {
  return (
    <div className="overflow-hidden">
      <div className="flex items-center justify-between mb-4.5">
        <h2 className="text-2xl font-bold text-dark-text">{title}</h2>
        {actions}
      </div>

      {filters && (
        <div className="flex items-center gap-3 pt-1 mb-6">{filters}</div>
      )}

      <div className="overflow-x-auto mb-6">
        <table className="w-full">
          <thead>
            <tr className="border-b border-dark-40">
              {headers.map((header, i) => (
                <th
                  key={i}
                  className="px-6 py-4 text-left text-sm font-medium text-dark-100"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{data.map(renderRow)}</tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        onPrevious={() => onPageChange(Math.max(1, currentPage - 1))}
        onNext={() => onPageChange(currentPage + 1)}
        hasPrevious={hasPrevious ?? currentPage > 1}
        hasNext={hasNext}
      />
    </div>
  );
}
